import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const MonthlyPmi = () => {
  const formBag = useFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.MonthlyPmi"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          label="PMI"
          innerText="/month"
          leftIcon="far fa-dollar-sign"
          decimalScale={2}
          allowNegative={false}
          tooltip="Private mortgage insurance, also called PMI, is a type of mortgage insurance you might be required to pay for if you have a conventional loan. Like other kinds of mortgage insurance, PMI protects the lender if you stop making payments on your loan."
        />
      )}
    />
  );
};
